export const StatusEndpoint = '/scripts/coaching_form/status'
export const StatusTypesEndpoint = '/scripts/coaching_form/status_types'
